var _path, _line, _line2, _line3, _mask, _rect;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.746 4.43807C11.746 4.39711 11.7287 4.35759 11.6969 4.32675L8.4959 1.21108C8.46072 1.1759 8.4106 1.15663 8.35904 1.15663H2.4053C1.71663 1.15663 1.15614 1.69542 1.15614 2.35711V13.6434C1.15614 14.3051 1.71663 14.8434 2.4053 14.8434H10.4973C11.186 14.8434 11.746 14.3051 11.746 13.6434V4.43807ZM12.9027 4.43807V13.6434C12.9027 14.9427 11.8236 16 10.4973 16H2.4053C1.07904 16 0 14.9427 0 13.6434V2.35711C0 1.05735 1.07904 0 2.4053 0H8.35904C8.71518 0 9.05012 0.135904 9.30313 0.382169L12.5041 3.49783C12.761 3.74892 12.9027 4.08289 12.9027 4.43807Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 12.5,
    x2: 8.5,
    y2: 12.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 10.5,
    x2: 8.5,
    y2: 10.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 8.5,
    x2: 8.5,
    y2: 8.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 7,
    height: 4,
    rx: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 7,
    height: 4,
    rx: 0.5,
    stroke: "white",
    strokeWidth: 2,
    mask: "url(#path-5-inside-1)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.c7fc598a.svg";
export { ForwardRef as ReactComponent };